import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export default function StoreSettingsIcon({ storeId }) {
    const history = useHistory()
    return <i title="Παράμετροι Καταστήματος" className="fas fa-cogs  mr-2" style={{ cursor: 'pointer' }} onClick={() => history.push(`edit-store/${storeId}`)}></i>
}
